import { ChatMessage } from '../types';

export function UserChatBlob({ message }: { message: ChatMessage }) {
    return (
        <div className='flex justify-end'>
            <div className={`max-w-xs rounded-2xl px-4 py-2 lg:max-w-md ${'bg-slate-700/60'} `}>
                <div className='text-sm break-words whitespace-pre-wrap'>{message.content}</div>
            </div>
        </div>
    );
}
